<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Paragraph-Style-2"><img alt="" class="_idGenObjectAttribute-1" src="image/1.png"/></p>
<p class="Book_Book_Subtitle">How to Make It a Better World</p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1"> </span></p>
<p class="Book_Book_Editors">The Editors of Conari Press</p>
<p class="Book_Book_Text">Foreword by Brenda Knight and Dawna Markova, PhD</p>
<p class="ParaOverride-2"><span class="CharOverride-2"> </span></p>
<p class="Book_Book_Text">Preface </p>
<p class="Book_Book_Text">by Daphne Rose Kingma</p>
<p class="ParaOverride-2"><span class="CharOverride-2"> </span></p>
<p class="pictures_Conari-Logo ParaOverride-3"><img alt="" class="_idGenObjectAttribute-2" src="image/cplogo_titlepage.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RandomActsKindness-1.vue?00f4a0ed